<template>
  <section
    ref="container"
    v-loading="loading"
    class="page-container"
    @click="()=>{setPolicy=false}">
    <div
      class="main-header ">
      <div
        class="flex-sb type-margin">
        <div class="">
          <div class="header-title flex">
            <span
              v-if="merchant_platform"
              class="table-icon__img icon">
              <img :src="getOptionName('serverTypeIcon',merchant_platform)" >
            </span>
            <span class="icon" >
              <font-awesome-icon
                icon="comment-alt"
                class="icon-color"/>
            </span>
            <span class="icon" >
              <span class="button-radius">{{detailData.enquiry_type_language}}</span>
            </span>
            <span
              class="hcid ticket-number"> <span class="number-color">{{detailData.enquiry_no}}</span></span>
          </div>

          <div class="header-title flex">
            <h3>{{ detailData.subject }}</h3>
          </div>
          <div class="flex flex-inline">
            <div>
              <span
                class="status-bar-span"
                :class="{
                  'pending':[2].includes(detailData.status),
                  'yellow-dark': [1].includes(detailData.status),
                  'yellow': [4].includes(detailData.status),
                  'green':detailData.status==3,
                  'red':detailData.status==5,
                }"
              >{{detailData.status_language}}</span>
            </div>
            <span class="header-date">Created</span>
            <span class="number-color number-fontsize">{{ detailData.created_at }}</span>
            <span class="header-date">Updated</span>
            <span class="number-color number-fontsize">{{ detailData.updated_at }}</span>

          </div>
        </div>
        <div class="form-item">
          <span>Assignee</span>
          <span>

            <v-select
              v-model="detailData.cs_id"
              icon="user-nurse"
              :list="assigneeList"
              :clearable="true"
              @change="selectAssignee"
            />
          </span>
        </div>
      </div>

      <div >
        <div >
          <section>
            <el-tabs v-model="activeTab">
              <el-tab-pane
                v-for="(tab, index) in businessTab"
                :key="index"
                :name="String(tab.name)"
              >
                <span slot="label">
                  <span class="flex">
                    <span>{{tab.label}}</span>
                    <el-badge
                      v-if="tab.name=='4'&&detailData.unread>0"
                      :value="detailData.unread"
                      :max="99"
                      class="aside-dot is-info"
                    >
                    </el-badge>
                  </span>
                </span>
              </el-tab-pane>
            </el-tabs>
          </section>
        </div>
      </div>
    </div>

    <div class="warning">
      <block-warning
        v-if="customer_profile.block_data && customer_profile.block_data.length"
        :customerProfile="customer_profile"></block-warning>
    </div>

    <div
      class="main-container">
      <div
        v-if="showMain"
        class="main-col">
        <div class="middle-col">
          <v-serviced-progress
            v-if="merchant_platform"
            class="mg-b-20"
            :agency-name="order_detail.agency_name"
            :is-fina="isFina"></v-serviced-progress>
          <section>
            <div v-show="activeTab === '1'">
              <enquiry-detail
                :form="detailData"
                @edit="handleEdit"></enquiry-detail>
              <div class="box box-remark">
                <span class="title fs-14">Remarks</span>
                <div class="remarks-container">
                  <div
                    v-for="(item, index) in remarkLogsData"
                    :key="index"
                    class="remark-box">
                    <div class="remark-header">
                      <span>{{ item.agent }}</span>
                      <span class="flex flex-center">
                        <span>{{ item.created_at }}</span>
                        <span
                          @click="handleDel(item.id)">
                          <font-awesome-icon
                            class="fs-14 red-color pointer mg-l-8 mg-r-8"
                            icon="trash-alt"></font-awesome-icon>
                        </span>
                      </span>
                    </div>
                    <p v-html="changeLineData(item.message)"></p>
                  </div>
                </div>
                <div class="remark-add">
                  <v-input
                    v-model="message"
                    class="mg-b-15"
                    append="Add"
                    type="textarea"
                    :rows="4"
                    @handlerAppend="handlerSendRemark"/>
                  <div class="text-right">
                    <v-button
                      green
                      :disabled="!message"
                      @click="handlerSendRemark">Apply</v-button>
                  </div>
                </div>
              </div>
            </div>
            <div v-show="activeTab == '2' ">
              <internal-document
                :customer="customer"
                :ticket-id="enquiryId"
                is-enquiry
                :list="detailData.internal_doc"
                @updateDetail="handlerGetTicketDetail"></internal-document>
            </div>
            <div v-show="activeTab === '3'">
              <support-log
                :logsData="supportLogsData"
                @change="changeSupportLogType" />
            </div>
            <div v-if="activeTab === '4'">
              <enquiry-message
                :detail="detailData"
                @refresh="handleRefresh"></enquiry-message>
            </div>

          </section>

        </div>
        <div class="right-col">
          <div class="box mg-t-0">
            <span
              class="label">Ticket</span>

            <div
              class="button-group">
              <!--              <span class="flex span-one">-->
              <!--                <font-awesome-icon-->
              <!--                  v-if="status==1"-->
              <!--                  icon="forward"></font-awesome-icon>-->
              <!--                <font-awesome-icon-->
              <!--                  v-if="status==2"-->
              <!--                  icon="check"></font-awesome-icon>-->
              <!--                <font-awesome-icon-->
              <!--                  v-if="status==3"-->
              <!--                  icon="exclamation-circle"></font-awesome-icon>-->
              <!--                <span-->
              <!--                  v-if="status==1"-->
              <!--                  @click="handlerSelectType(1,1)"> Set Handling</span>-->
              <!--                <span-->
              <!--                  v-if="status==2"-->
              <!--                  @click="handlerSelectType(2,1)"> Set Resolved</span>-->
              <!--                <span-->
              <!--                  v-if="status==3"-->
              <!--                  @click="handlerSelectType(3,1)"> Reopen Ticket</span>-->
              <!--              </span>-->
              <span
                class="span-two flex flex-align-center"
                @click.stop="handlerSetPolicy">
                <span
                >{{detailData.status_language}}</span>
                <i class="el-icon-caret-bottom"></i>
              </span>

            </div>
            <ul
              v-if="setPolicy"
              class="setting-menu">
              <li
                v-for="(item,index) in enquiry_status"
                :key="index"
                @click="handlerSelectType(item.id,2)">
                <div class="with-icon">
                  <i
                    v-show="status==item.id"
                    class="el-icon-check"></i>
                </div>
                <span>{{item.name}}</span>
              </li>
            </ul>

            <!--            <div-->
            <!--              class="width-fill">-->
            <!--              <v-button-->
            <!--                icon="circle-exclamation"-->
            <!--                red-->
            <!--                class="width-fill"-->
            <!--                @click="handlerSend">-->
            <!--                Unable to contact-->
            <!--              </v-button>-->
            <!--            </div>-->
            <div
              v-if="detailData.status!=3&&detailData.enquiry_type==20"
              class="width-fill mg-t-10">
              <v-button
                icon="ticket-simple"
                gray
                class="width-fill"
                @click="handleCreateEndorsement('new-endorsement-ticket')">
                Create Endorsement Ticket
              </v-button>
            </div>
            <div
              v-if="detailData.status!=3&&detailData.enquiry_type==30"
              class="width-fill mg-t-10">
              <v-button
                icon="ticket-simple"
                gray
                class="width-fill"
                @click="handleCreateEndorsement('new-claim-ticket')">
                Create Claim Ticket
              </v-button>
            </div>
          </div>
          <div class="box">
            <div class="flex flex-sb">
              <span class="title">Handling</span>
              <span
                class="blue hand"
                @click="showHandling = true">Edit</span>
            </div>
            <div>
              <div class="flex flex-align-center">
                <div class="customer-ava">
                  <img
                    v-if="detailData.agency_icon"
                    ref="img"
                    :src="detailData.agency_icon">
                  <template v-else>
                    <img
                      src="@/assets/images/icon/Personal-icon.png">
                  </template>
                </div>
                <span
                  class="fs-12 fw-600 color-gray60">{{detailData.agency_name}}</span>
                <!--                <template v-else>-->
                <!--                  <span class="unname none-data">No attached</span>-->
                <!--                </template>-->
              </div>
            </div>
          </div>
          <div
            v-if="showPolicyInfo"
            class="box">
            <div class="flex flex-sb">
              <span class="title">Policy Info</span>
              <span
                class="blue hand"
                @click="openDialog('attach-policy')">{{detailData.policy_info?'Edit':'Add'}}</span>
            </div>
            <div  v-if="detailData.policy_info">
              <div

                class="flex ">
                <div class="flex-icon">
                  <span class="icon-width">
                    <span
                      v-if="detailData.policy_info.company_id !== 0"
                      v-tooltip="detailData.policy_info.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', detailData.policy_info.company_id).logo? getOptionData('companySmallIcon', detailData.policy_info.company_id).logo: detailData.policy_info.company_icon"
                      >
                    </span>
                  </span>
                  <span class="icon-width icon-margin-top">
                    <span
                      v-tooltip="detailData.policy_info.class_language"
                      class="icon icon-content "
                    >
                      <font-awesome-icon
                        v-if="detailData.policy_info.class_id"
                        :icon="getOptionName('iconOptions', detailData.policy_info.class_id)" />
                    </span>
                  </span>
                </div>

                <router-link
                  v-if="[90,93].includes(detailData.policy_info.product_id)"
                  :to="{path:'/records/micropolicy/detail',query:{
                    id: detailData.policy_info.id,
                    pcy_id:detailData.policy_info.pcy_id,
                    product_id: detailData.policy_info.product_id}}"
                  class="plan-name">
                  {{ detailData.policy_info.plan }}
                  {{ detailData.policy_info.pcy_class }}
                  <br />{{ detailData.policy_info.trm_of_cvr_language }}
                  <!--                  <br />Plan-->
                </router-link>
                <router-link
                  v-else
                  :to="{path:'/records/policy/detail',query:{
                    id: detailData.policy_info.id,
                    pcy_id:detailData.policy_info.pcy_id,
                    product_id: detailData.policy_info.product_id}}"
                  class="plan-name">
                  {{ detailData.policy_info.plan }}
                  {{ detailData.policy_info.pcy_class }}
                  <br />{{ detailData.policy_info.trm_of_cvr_language }}
                  <!--                  <br />Plan-->
                </router-link>
              </div>
              <ul>
                <li>
                  <span>Issue Date</span>
                  <span>{{ detailData.policy_info.issue_dt  }}</span>
                </li>
                <li>
                  <span>Policy No.</span>
                  <span>{{ detailData.policy_info.pcy_no }}</span>
                </li>
                <li>
                  <span>Policy Period</span>
                  <span>{{ detailData.policy_info.period_start }} - {{ detailData.policy_info.period_end }}</span>
                </li>
                <li>
                  <span>Status</span>
                  <span
                    class="policy-span-status"
                    :class="{
                      'orange': [401, 301].includes(detailData.policy_info.pcy_stts),
                      'yellow-dark': detailData.policy_info.pcy_stts == 410,
                      'blue': [420, 505, 705].includes(detailData.policy_info.pcy_stts),
                      'green': [425, 501, 510, 701].includes(detailData.policy_info.pcy_stts),
                      'red': [801, 0].includes(detailData.policy_info.pcy_stts),
                      'purple': [710].includes(detailData.policy_info.pcy_stts),
                    }">{{ detailData.policy_info.pcy_stts_language }}</span>
                </li>
                <li>
                  <span>Account</span>
                  <span><i :class="detailData.policy_info.customer_id>0?'el-icon-user-solid':'el-icon-user'"/> {{ detailData.policy_info.customer_id>0?'Having an Account':'Without account' }}</span>
                </li>
              </ul>
            </div>
            <template v-else>
              <span class="unname none-data">No policy attached</span>
            </template>
          </div>
          <div
            v-if="showQuoteInfo"
            class="box">
            <div class="flex flex-sb">
              <span class="title">Quote Info</span>
              <span
                class="blue hand"
                @click="openDialog('attach-quote')">{{detailData.quote_info?'Edit':'Attach'}}</span>
            </div>
            <template  v-if="detailData.quote_info">
              <div
                class="flex ">
                <div class="flex-icon">
                  <span class="icon-width">
                    <span
                      v-if="detailData.quote_info.company_id !== 0"
                      v-tooltip="detailData.quote_info.company_language"
                      class="icon icon-content"
                    >
                      <img
                        :src="getOptionData('companySmallIcon', detailData.quote_info.company_id).logo? getOptionData('companySmallIcon', detailData.quote_info.company_id).logo: detailData.quote_info.company_icon"
                      >
                    </span>
                  </span>
                  <span class="icon-width icon-margin-top">
                    <span
                      v-tooltip="detailData.quote_info.class_language"
                      class="icon icon-content "
                    >
                      <font-awesome-icon
                        v-if="detailData.quote_info.class_id"
                        :icon="getOptionName('iconOptions', detailData.quote_info.class_id)" />
                    </span>
                  </span>
                </div>
                <router-link
                  :to="{path:'/records/quote/detail',query:{order_id: detailData.quote_info.id,
                                                            product_id: detailData.quote_info.product_id}}"
                  class="plan-name">
                  {{ detailData.quote_info.pcy_class }}
                  <!-- {{ detailData.quote_info.product_language }} Insurance -->
                  <br />{{ detailData.quote_info.plan }}
                  <!--                  <br />Plan-->
                </router-link>
              </div>
              <ul>
                <li>
                  <span>Created</span>
                  <span>{{ detailData.quote_info.created_at  }}</span>
                </li>
                <li>
                  <span>Quote No.</span>
                  <span>{{ detailData.quote_info.quotation_number}}</span>
                </li>
                <li>
                  <span>Policy Period</span>
                  <span>{{ detailData.quote_info.period_start }} -{{ detailData.quote_info.period_end }}</span>
                </li>
                <li>
                  <span>Total Payable</span>
                  <span>${{ detailData.quote_info.amount }}</span>
                </li>
              </ul>
            </template>
            <template v-else>
              <span class="unname none-data">No quote attached</span>
            </template>
          </div>
          <right-customer-detail
            :detail-data="detailData"
            can-customer-add
            :show-customer="isFina?!!referrer:detailData.customer_id>0"
            is-edit
            :is-fina="isFina"
            is-enquriy
            :is-share="false"
            has-original
            :customer-profile="customer_profile"
            @view="viewCustomer"
            @editDes="editDescription"
            @success="handler().getUpdateDetailData(0)"
            @attach="editCustomer">
          </right-customer-detail>
          <div class="box">
            <div class="flex flex-sb">
              <span class="title">Related Ticket</span>
              <span
                class="blue hand"
                @click="event().onAttatchTicket(0)">{{ticketSelectArr.length>0?'Edit':'Add'}}</span>
            </div>
            <template v-if="ticketSelectArr.length>0">
              <router-link
                v-for="(item, index) in ticketSelectArr"
                :key="index"
                class="tr pointer tr-margin tr-a"
                :to="{path:'/tickets/detail',query:{ticket_id:item.id}}"
                @click="viewTicket(item.id)">
                <span>
                  <span class="span-status">{{ item.type_language }}</span>
                </span>
                <span class="blue">{{ item.subject }}</span>
              </router-link>
            </template>
            <template v-else>
              <span class="unname none-data">No related tickets</span>
            </template>
          </div>

        </div>
      </div>
      <div
        v-if="!showMain"
        class="main-edit">
        <edit-enquiry
          :from="detailData"
          :remark="remarkDetail"
          :list="accountList"
          @updateRemark="handleUpdateRemark"
          @success="handleUpdateDetail"
          @cancel="handleCancel"></edit-enquiry>
      </div>
    </div>

    <to-top
      v-if="!showMain"
      :el='container'></to-top>

    <!-- dialog -->
    <snooze-ticket
      ref="snooze-ticket"
      :ticket-id="enquiryId"
      :form="detailData"
      is-enquiry
      @success="handler().getUpdateDetailData(0)" />
    <resolve-ticket
      ref="resolve-ticket"
      :ticketId="enquiryId"
      @success="handler().getUpdateDetailData(0)" />
    <contact-dialog
      ref="contact-dialog"
      :ticketId="enquiryId"
      :initCustomerId="detailData.customer_id"
      :initPhone="customer? customer.phone||customer.contact_phone: ''"
      :initEmail="customer? customer.send_email: ''"
      :customerData="customerData"
      :shareLink="initContent"
      :type="contactType" />
    <attach-user
      ref="attach-user"
      :ticketId="enquiryId"
      :is-fina="isFina"
      is-enquiry
      :customer-type="select_type"
      @success="handler().getUpdateDetailData(0)" />

    <attach-policy
      ref="attach-policy"
      :ticketId="enquiryId"
      :customerId="customerId"
      is-enquiry
      :is-fina="isFina"
      :policyId="detailData.policy_info? detailData.policy_info.id: ''"
      @success="handler().getUpdateDetailData(0)" />
    <attach-quote
      ref="attach-quote"
      :ticketId="enquiryId"
      is-enquiry
      :is-fina="isFina"
      :customerId="customerId"
      @success="handler().getUpdateDetailData(0)" />

    <related-tickets
      ref="related-tickets"
      :ticketId="enquiryId"
      is-enquiry
      :is-fina="isFina"
      :referTickList="ticketSelectArr"
      @success="handler().getUpdateDetailData(0)" />

    <edit-description
      ref="edit-description"
      :detailData="customer_profile"
      :customerId="customerId"
      @update="getUpdateAccountData"></edit-description>
    <send-email-sms
      ref="send-email-sms"
      :form="detailData"
      :type="2"
      :initContent="initContactContent"
      :lastContent="lastContactContent"
      :emailListTitle="emailListTitle"
      :emailTitle="emailTitle"
      :skip="false"
      @send="handlerEmailSmsSend"
    />
    <enquiry-handling-dialog
      v-model="showHandling"
      :detail="detailData"
      :agencyId="detailData.cs_team_id"
      @refresh="handleRefresh"></enquiry-handling-dialog>
    <new-endorsement-ticket
      ref="new-endorsement-ticket"
      :orderId="detailData.order_id"
      :customer="detailData.customer"
      is-enquiry
      :form="{...detailData.order_detail,...detailData}" />
    <new-claim-ticket
      ref="new-claim-ticket"
      :orderId="detailData.order_id"
      is-enquiry
      :customer="detailData.customer"
      :form="ticketParams"
    />
  </section>
</template>
<script>
import SupportLog from '../tickets/components/support-log'
import InternalDocument from '@/views/components/internal-document'
import SnoozeTicket from '../tickets/dialogs/snooze-ticket.vue'
import ResolveTicket from '../tickets/dialogs/resolve-ticket'
import ContactDialog from '../tickets/dialogs/new-contact-dialog'
import AttachUser from '../tickets/dialogs/attach-user'
import AttachPolicy from '../tickets/dialogs/attach-policy'
import AttachQuote from '../tickets/dialogs/attach-quote'
import RelatedTickets from '../tickets/dialogs/related-tickets'
import BlockWarning from '@/views/components/block-warning'
import EditDescription from '@/views/accounts/dialog/edit-description'
import ContactCustomer from '@/views/components/new-contact-customer'
import enquiryDetail from './compenment/enquiry-detail'
import enquiryMessage from './compenment/enquiry-message'
import editEnquiry from './compenment/enquiry-form'
import NewEndorsementTicket from '@/views/tickets/dialogs/new-endorsement-ticket'
import NewClaimTicket from '@/views/tickets/dialogs/new-claim-ticket'
import {
  getEnquiryRemarkList,
  getEnquiryDetail,
  addEnquiryRemark,
  setEnquiryResolved,
  setEnquiryUnsnooze,
  setEnquiryCS,
  unableContactEmail,
  delEnquiryRemark
} from '@/api/enquiry'
import {getAccountDetail} from '@/api/account'
import {mapActions, mapState} from 'vuex'
import MixinOptions from '@/mixins/options'
import SendEmailSms from '@/views/components/dialogs/send-email-sms'
import rightCustomerDetail from '@/views/components/right-customer-detail'
import EnquiryHandlingDialog from '@/views/enquiry/compenment/enquiry-handling-dialog'

export default {
  name: 'Detail',
  components: {
    EnquiryHandlingDialog,
    SupportLog,
    InternalDocument,
    SnoozeTicket,
    ResolveTicket,
    ContactDialog,
    AttachUser,
    AttachPolicy,
    AttachQuote,
    RelatedTickets,
    BlockWarning,
    EditDescription,
    enquiryDetail,
    editEnquiry,
    SendEmailSms,
    rightCustomerDetail,
    enquiryMessage,
    NewEndorsementTicket,
    NewClaimTicket
  },
  mixins: [MixinOptions],
  data() {
    return {
      loading: false,
      showHandling: false,
      select_type:1,
      initContent: '',
      way: '',
      container: null,
      showEdit: false,
      setPolicy:false,
      policyType:1,
      supportLogType: 0, // support logs 組件 type
      editStatus: false,
      contactType: 0,
      activeTab: '1',
      remarkDetail:{},
      businessTab: [
        {
          label: 'Request Detail',
          name: '1'
        },
        {
          label: 'Message',
          name: '4'
        },
        {
          label: 'Internal Document',
          name: '2'
        },
        {
          label: 'Support Log',
          name: '3'
        }
      ],
      // data
      detailData: {
        relation: {
          client_profile: null
        }
      },
      assignee: '',
      customer_profile:{},
      message:'',
      step: 0,
    }
  },
  computed: {
    ...mapState('common', ['globalOptions']),
    ...mapState('ticket', ['ticketData', 'referData', 'refreshPage']),
    enquiry_status(){
      return this.globalOptions.enquiry_status || []
    },
    ticketParams(){
      let {order_detail,accident_date,name,phone} = this.detailData||{}
      let {product_id,nm_traveler_list,nm_pa_list} = order_detail||{}
      let list = []
      if([14,18].includes(Number(product_id))){
        list = Number(product_id)==14?nm_traveler_list:nm_pa_list
      }
      return {...order_detail,list,accident_date,name,phone}
    },
    accountList(){
      let {order_detail,accident_date,name,phone} = this.detailData||{}
      let {product_id,nm_traveler_list,nm_pa_list} = order_detail||{}
      let list = []
      if([14,18].includes(Number(product_id))){
        list = Number(product_id)==14?nm_traveler_list:nm_pa_list
      }
      return list
    },
    isFina(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform==2
    },
    merchant_platform(){
      let {merchant_platform} = this.detailData||{}
      return merchant_platform||1
    },
    emailListTitle(){
      let {unable_contact_subject} = this.detailData||{}
      return unable_contact_subject
    },
    emailTitle(){
      let {unable_contact_title} = this.detailData||{}
      return unable_contact_title
    },
    initContactContent(){
      let {unable_contact_content} = this.detailData||{}
      return unable_contact_content
    },
    lastContactContent(){
      let {unable_contact_message} = this.detailData||{}
      return unable_contact_message
    },
    customer_description(){
      let str = this.customer_profile.description
      if(str){
        str = str.replaceAll('\n', '<br />')
      }
      return str
    },
    avt_pic(){
      const {avatar_pic={}} = this.detailData.customer||{}
      return avatar_pic&&avatar_pic.url||''
    },
    contact_data(){
      const { contact_data } = this.detailData
      return contact_data || {}
    },
    // 控制左邊 policy 和 quote info
    showPolicyInfo() {
      return  true
      return [1, 3, 6].includes(this.type)
    },
    showQuoteInfo() {
      return  true
      return [1].includes(this.type)
    },
    // 1-Open 2-Snooze 3-Resolved
    status() {
      return this.detailData.status || 1 // 優化 resolved
    },
    is_snooze() {
      let {is_snooze=0} = this.detailData||{}
      return is_snooze// 優化 resolved
    },
    enquiryId() {
      let {id} =this.$route.query||{}
      return id
    },
    ticketSelectArr(){
      return this.detailData.relation_ticket_list||[]
    },
    customerId() {
      if(this.isFina){
        return this.referCustomerId
      }
      return this.detailData.customer_id
    },
    supportLogsData() {
      // logs 數據
      return this.detailData.support_log || []
    },
    remarkLogsData() {
      // logs 數據
      return this.remarkDetail || []
    },
    showMain() {
      return !this.showEdit
    },

    showStatusBar() {
      return this.status == 3
    },
    disabledSnooze() {
      return  false
      if(this.detailData.is_snooze === 1) {
        return true
      }
      return this.detailData.is_snooze === 1
    },
    disabledResolved() {
      return this.showStatusBar && this.is_snooze !== 1
    },
    customerData(){
      let{phone,send_email} = this.customer_profile||{}
      return{
        contact_phone:phone||'',
        contact_email:send_email||''
      }
    },
    customer(){
      let{customer={}} = this.detailData||{}
      return customer||{}
    },
    isShowName(){
      let {isrd_nm} = this.customer_profile
      if(isrd_nm)
        return isrd_nm.trim()!=''
      else return  false
    },

    referCustomerId() {
      const {referrer} =  this.detailData||{}
      let {user_id} = referrer||{}
      return  user_id||''
    },
    referrer() {
      const {referrer} =  this.detailData
      return referrer
    },

    documentData(){
      return this.isSMEProduct?this.referData:this.detailData.relation
    },
    has_block_data(){
      let {block_data=[]} = this.customer_profile||{}
      return block_data.length>0
    },
    order_detail(){
      let {order_detail} = this.detailData||{}
      return order_detail||{}
    }
  },
  watch: {
    enquiryId: {
      immediate:true,
      handler(val) {
        this.handler().getDetailData()
      }
    },
    customerId:{
      immediate:true,
      handler(val){
        if(val)
          this.network().getAccountDetail({customer_id:val})
      }
    },
    $route:{
      immediate:true,
      handler(val){
        let {query} = val||{}
        let {tab} = query||{}
        if(tab){
          this.activeTab = String(tab)
        }
      }
    }
  },
  async created() {
  },
  mounted(){
    this.container = this.$refs['container'].parentElement
  },
  methods: {
    handleDel(remark_id){
      this.$ConfirmBox({
        isNewConfirm:true,
        width:500,
        title:'Delete Remark',
        confirmBtn:'Delete',
        isBtnRed:true,
        message: 'Are you sure you wana delete this remark?'
      }).then(() => {
        this.network().delEnquiryRemark({remark_id})
      })

    },
    handleRefresh(){
      this.showEdit = false
      this.handler().getUpdateDetailData()
    },
    handleCreateEndorsement(target){
      this.$refs[target].changeDialog()
      // this.$ConfirmBox({
      //   isNewConfirm:true,
      //   width:500,
      //   title:'Create Endorsement Ticket',
      //   confirmBtn:'Confirm',
      //   isGreen:true,
      //   message: 'Are you sure to create a endorsement ticket?'
      // }).then(() => {
      // })
    },
    handlerEmailSmsSend(content){
      let params = {
        msg_content:content
      }
      this.network().unableContactEmail(params)
    },
    handlerEmailSmsSkip(){
      let params = {
        msg_content:''
      }
      this.network().unableContactEmail(params)
    },
    handlerSend(){
      this.$refs['send-email-sms'].changeDialog()
    },
    handleUpdateRemark(){
      this.network().getEnquiryRemarkList()
    },
    handleEdit(){
      this.showEdit = true
    },
    handleCancel(){
      this.showEdit = false
    },
    getUpdateAccountData() {
      this.network().getAccountDetail({customer_id:this.customerId})
    },
    editDescription(){
      this.$refs['edit-description'].changeDialog()
    },
    handlerSetPolicy(){
      this.setPolicy =  !this.setPolicy
    },
    handlerSelectType(data,btn){
      this.policyType=data
      this.setPolicy =false
      let params ={}
      params.btn = btn
      params.status = data
      this.network().setEnquiryResolved(params)
    },
    handlerDialog(target) {
      this.$refs[target].changeDialog()
    },
    routerTo(path) {
      this.$router.push(path)
    },
    selectAssignee(id) {
      id = id?id:0
      this.network().setEnquiryCS({
        enquiry_id: this.enquiryId,
        assignee_id: id
      })
    },
    viewCustomer(type) {
      this.$router.push({
        path: '/accounts/detail',
        query: {
          customer_id: this.customerId
        }
      })
    },
    viewTicket(ticketId) {
      this.$router.push({
        path: '/tickets/detail',
        query: {
          ticket_id: ticketId
        }
      })
    },
    editCustomer(type) {
      this.select_type = this.isFina?2:1
      this.$refs['attach-user'].changeDialog()
    },
    openDialog(target) {
      this.$refs[target].changeDialog()
    },
    // 獲取 support logs type 數據
    changeSupportLogType(type) {
      this.supportLogType = type
      this.handler().getUpdateDetailData()
    },
    handlerAddRemark(data) {
      this.network().addEnquiryRemark({
        enquiry_id: this.enquiryId,
        ...data
      })
    },
    handlerSendRemark(msg) {
      let content = msg? msg : this.message
      this.network().addEnquiryRemark({
        enquiry_id: this.enquiryId,
        content
      })
    },
    handleUpdateDetail(){
      this.showEdit = false
      this.handler().getUpdateDetailData()
    },
    handlerGetTicketDetail(){
      this.network().getEnquiryDetail()
    },
    event() {
      return {
        onAttatchTicket: () => {
          this.$refs['related-tickets'].changeDialog()
        }
      }
    },
    handler() {
      return {
        getDetailData: async () => {
          //获取信息详情
          await this.network().getEnquiryDetail()

          await this.network().getEnquiryRemarkList()
        },
        getUpdateDetailData: async () => {
          //获取信息详情
          await this.network().getEnquiryDetail()
        },
      }
    },
    network() {
      return {
        getAccountDetail: async ({customer_id}) => {
          const {data} = await getAccountDetail({
            customer_id
          })
          let {customer_profile} = data
          this.customer_profile = customer_profile
        },
        getEnquiryDetail: async (params = {}) => {
          const { data } = await getEnquiryDetail({
            enquiry_id: this.enquiryId,
            type:this.supportLogType
          })
          this.detailData = data
          this.assignee = this.detailData.cs_id
        },
        getEnquiryRemarkList: async () => {
          const { data } = await getEnquiryRemarkList({
            enquiry_id: this.enquiryId,
          })
          this.remarkDetail = data
        },
        addEnquiryRemark: async params => {
          const { data } = await addEnquiryRemark(params)
          this.network().getEnquiryRemarkList()
          this.message = ''
          this.$message({
            type: 'success',
            message: data.message_language
          })
        },
        setEnquirySnooze: async () => {
          const { data } = await setEnquirySnooze({
            enquiry_id: this.enquiryId
          })
          this.handler().getUpdateDetailData()
        },
        // unsnooze
        setEnquiryUnsnooze: async () => {
          const { data } = await setEnquiryUnsnooze({
            enquiry_id:  this.enquiryId
          })
          this.handler().getUpdateDetailData()
        },
        setEnquiryCS: async params => {
          const { data } = await setEnquiryCS(params)
          this.$message({
            type: 'success',
            message: 'Success'
          })
        },
        setEnquiryResolved: async (params) => {
          const { data } = await setEnquiryResolved({
            enquiry_id: this.enquiryId,
            ...params
          })
          this.handler().getUpdateDetailData(0)
        },
        unableContactEmail: async (params) => {
          const { data } = await unableContactEmail({
            enquiry_id: this.enquiryId,
            ...params
          })
          this.handler().getUpdateDetailData(0)
        },
        delEnquiryRemark: async (params) => {
          const { data } = await delEnquiryRemark({
            enquiry_id: this.enquiryId,
            ...params
          })
          this.network().getEnquiryRemarkList()
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
@import '../../assets/css/pay-main-header';
.page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .none-data{
    color: #6A737D;
  }
  .flex-wrap{
    flex-wrap: wrap;
    text-decoration: none;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }

  .span-status{
    padding: 1px 8px;
    color: #fff;
    border-radius: 50px;
    font-size: 14px;
    margin-right: 10px;
    background: #fff;
  }
  .status-bar-span{
    padding: 1px 8px;
    border-radius: 25px;
    white-space: nowrap;
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    color: #24292E;
    background: #fff;
    margin-right: 15px;
  }
  .span-status-stts{
    //font-family: Inter;
    padding: 1px 8px;
    border-radius: 25px;
    white-space: nowrap;
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    margin-right: 15px;
    color: #fff!important;
    //height: 18px;

    //background: #E36209;
    border-radius: 100px;
    &.orange-light {
      background: #E36209;
    }
    &.yellow-dark {
      background: #DBAB09;
    }
    &.blue {
      background: #0366D6;
    }
    &.green {
      background: #28A745;
    }
    &.red {
      background: #D73A49;
    }
    &.purple {
      background: #6F42C1;
    }

  }
  .yellow-dark{
    border: 1px solid #735C0F;
    color: #735C0F;
  }
  .yellow{
    border: 1px solid #DBAB09;
    color: #DBAB09;
  }
  .pending{
    border: 1px solid #0366D6;
    color: #0366D6;
  }
  .red{
    border: 1px solid #D73A49;
    color: #D73A49;
  }
  .green{
    border: 1px solid #22863A;
    color: #22863A;
  }
  .warning{
    padding: 20px 70px;
  }
  .main-container {
    padding: 0 70px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      width: 100%;
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }

    .middle-col {
      flex: 1;
      min-width: 600px;
      /*width: calc(100% - 280px)!important;*/
      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
        display: inline-block;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
        &.mg-t-0{
          padding-top: 0;
        }
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
        &.is_snooze{
          background: #DBAB09;
          border: 1px solid rgba(27, 31, 35, 0.15);
          color: #FFFFFF;
        }
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
            .tag{
              .span-tag{
                display: inline-block;
                border-radius: 100px;
                height: 18px;
                background: #FFFFFF;
                padding: 0px 8px;
                font-weight: 600;
                font-size: 12px;
                line-height: 18px;
                box-sizing: content-box;
                white-space: nowrap;
                margin-bottom: 4px;
                &.verified{
                  border: 1px solid #22863a;
                  color: #22863a;
                }
                &.pending_verify{
                  border: 1px solid #dbab09;
                  color: #dbab09;
                }
                &.not_verify{
                  border: 1px solid #d73a49;
                  color: #d73a49;
                }
                &.unread-uplod{
                  border: 1px solid #f66a0a;
                  color: #c24e00;
                }
                &.professional-status, &.coupon-status, &.discount-status{
                  border: 1px solid #0366d6;
                  color: #0366d6;
                }
                &.green {
                  background: #DCFFE4;
                  color: #28A745;
                  border: none;
                }
                &.orange {
                  background-color:#FFF5B1 ;
                  color:  #B08800;
                  border: none;
                }
                &.red {
                  background: #D73A49;
                  color:#fff;
                  border: none;
                }
              }
            }
          }

          span:first-child {
            font-weight: bold;
          }
        }
        li:first-child {
          border-top-left-radius: 6px;
          border-top-right-radius: 6px;
        }
        li:last-child {
          border-bottom-left-radius: 6px;
          border-bottom-right-radius: 6px;
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-bottom: 1px solid #dddfe7;

        .title {
          margin-bottom: 5px;
        }
      }

      .action-box {
        margin: 10px -15px 0 -15px;
        padding: 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;
      }

      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }
      .amount-payable {
        border: 1px solid rgba(4,66,137,0.2);
        border-radius: 10px;
        background-color: #DBEDFF;
        //margin-bottom: 30px;
        &.border-b{
          margin-top: 0;
        }
        .title {
          margin-bottom: 0;
          padding-top: 15px;
          padding-bottom: 5px;
        }

        .amount {
          display: block;
          padding-bottom: 20px;
          font-size: 28px!important;
          color: #586069;
        }
        .payment-disblock{
          display: block!important;
          .size-blue{
            color: #0366D6;
            font-family: Inter;
            font-size: 12px;
            cursor: pointer;
          }
        }
        .payment-status{
          display:flex ;
          justify-content: space-between;
          margin-bottom: 10px;
          .flex{
            align-items: center;
          }
          .dot{
            margin-right: 8px;
            display: block;
            border-radius: 50%;
            height: 16px;
            width: 16px;
            border: 1px solid rgba(0,0,0,0.2);
            background-color: #D73A49;
          }
          .green{
            background: #28A745!important;
          }
          .icon{
            margin-right: 5px;
          }
          .text-color{
            color: #0366D6;
            font-size: 12px;
          }
          .size-italic{
            font-style:italic;
            font-size: 12px;
            color: #6A737D;
          }
        }
        .send-color{
          color: #0366D6;
          font-size: 14px;
          font-weight: 500;
        }
        .button-list{
          margin: 20px 0;
          .el-button{
            margin-right: 8px;
            width: 50%;
            font-size: 14px;
          }
        }

      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }


    }
  }
  .remarks-container {
    z-index: 1;
    max-height: 300px;
    overflow-y: auto;

    .remark-box {
      margin-bottom: 10px;
      font-size: 12px;
      color: #586069;

      .remark-header {
        display: flex;
        justify-content: space-between;

        span:first-child {
          font-weight: 600;
        }
      }

      p {
        //padding-bottom: 10px;
        color: #586069;
      }
    }
  }
  .dialog-container {
    padding-left: 15px;
    color: #616266;

    h1 {
      font-size: 24px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;

      h1 {
        font-size: 24px;
      }
    }

    .dialog-content {
      padding-top: 15px;

      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 70px 0px 70px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FAFBFC;
    .icon-color{
      color:#6A737D;
    }
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    ::v-deep .el-tabs--top{
      margin-top: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
    .type-margin{
      margin-bottom: 20px;
    }
  }
}
.bg-green {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #68C23A;
  color: white;
  p {
    padding-bottom: 5px;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-warning {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #e6a23d;
  color: white;
  p {
    padding-bottom: 5px;
  }
  .label {
    color: white;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
  &__yellow {
    background: #FFFBDD;
    border-radius: 15px;
    border: 1px solid rgba(176, 136, 0, 0.2);
    .flex,.flex__button{
      .width-80{
        width: 80%;
      }
    }
  }
}
.bg-skyblue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #409eff;
  color: white;
  p {
    padding-bottom: 5px;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-blue {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #d9ecff;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
    display: block;
  }
}
.bg-b3d9ff {
  background: #b3d9ff;
}
.bg-sky-blue {
  background: #409EFF;;
  color: white;
  .label {
    color: white;
  }
}
::v-deep .edit-container{
  padding: 0px!important;
}
.tr-margin{
  margin-bottom: 10px;
}
.tr-a{
  display: block;
}


.setting  .page-container {
  position: relative;
  color: #303133;
  background: #fff;
  margin: -20px;
  .hand{
    cursor:pointer;
  }
  .small{
    font-weight: normal!important;
  }
  .unname{
    font-style:italic;
    font-weight: normal!important;
  }
  .flex-wrap{
    flex-wrap: wrap;
    text-decoration: none;
  }
  .top-bar {
    padding-top: 5px;
    color: #e6a23d;
    font-size: 13px;
    font-weight: bold;
    border-top: 2px solid #e6a23d;
  }
  .main-container {
    padding: 0 70px;
    display: flex;
    justify-content: space-between;
    margin: 20px auto 0 auto;
    // max-width: 100%;
    // overflow: auto;
    .left-col {
      margin-right: 15px;
      width: 250px;
      color: #616266;

      .title {
        display: block;
        margin-bottom: 5px;
        font-weight: bold;
        font-size: 14px;
      }

      .name {
        display: block;
        margin-bottom: 10px;
        font-weight: bold;
        font-size: 16px;
      }

      .label {
        display: inline-block;
        margin: 10px 0;
        font-size: 14px;
        color: #616266;
        font-weight: 500;
      }

      .el-button {
        margin-top: 20px;
      }



      .info-container {
        margin: 10px -15px 0 -15px;
        padding: 0 15px 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;

        .plan-info-box {
          .logo {
            width: 80px;
            height: 45px;

            img {
              max-width: 80px;
              max-height: 45px;
            }
          }

          p {
            padding-left: 10px;
            font-size: 14px;
            line-height: 18px;
            font-weight: 500;
            color: #616266;
          }
        }

        .info-box {
          margin: 5px 0 0 0;
          color: #616266;

          & > div:last-child {
            font-size: 14px;
            font-weight: bold;
          }
        }
      }
    }

    .main-col {
      flex: 1;
      display: flex;
    }

    .main-edit {
      width: 100%;
      .top-header {
        display: flex;

        .card:last-child {
          margin-left: 15px;
          width: 250px;
        }

        .title {
          display: inline-block;
          margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
        }

        .btn-list {
          .el-button {
            display: block;
            margin: 0 0 5px 0;
          }
        }
      }
    }

    .middle-col {
      flex: 1;
      min-width: 600px;
      /*width: calc(100% - 280px)!important;*/
      .card {
        margin-bottom: 15px;
      }

      .draft-container {
        padding: 10px;
        background: #91939A;
        border-radius: 4px;
        color: white;

        span {
          display: block;
        }

        .title {
          font-size: 16px;
          font-weight: bold;
          color: white;
        }

        .msg {
          padding: 5px 0;
          font-size: 14px;
        }
      }

      .el-tabs {
        margin: 10px 0 0 0;
      }
    }

    .info-container {
      color: #616266;

      h1 {
        padding-bottom: 10px;
        font-size: 24px;
      }

      .info-content {
        display: flex;
        justify-content: space-between;
        margin: 0 -15px;
        padding: 0 15px 0 15px;
        // border-top: 1px solid rgba(0, 0, 0, 0.1);
        color: #91939a;
        font-size: 14px;

        .label {
          display: block;
          // margin-bottom: 10px;
          font-size: 14px;
          font-weight: bold;
          color: #616266;
        }
      }
    }

    .right-col {
      margin-left: 30px;
      width: 280px;
      //padding:0 0 0 15px;
      .icon{
        margin-right: 15px;
        img{
          height: 22px;
          width: 22px;
        }
      }
      .icon-content{
        height: 22px;
        width: 22px;
        border-radius: 5px;
        background-color: #E1E4E8;
        color: #6A737D;
        font-size: 14px;
        text-align: center;
        line-height: 22px;
      }
      .box-remark{
        border-bottom: 0!important;
      }
      .box{
        padding: 29.5px 0;
        border-bottom: 1px solid #D1D5DA;
      }
      .plan-name{
        color: #0366D6;
        font-family: Inter;
        font-size: 14px;
        font-weight: 600;
        letter-spacing: 0;
        text-decoration: none!important;
      }

      .button-weight{
        color: #24292E;
        font-family: Inter;
        //font-size: 14px;
        font-weight: 500!important;
        //padding: 6.5px 17px;
        padding: 10px 20px;
      }

      ul {
        margin-top: 15px;
        li {
          display: flex;
          padding: 5px;
          list-style: none;
          color: #606266;
          font-size: 12px;
          line-height: 14px;
          span {
            flex: 1;
          }

          span:first-child {
            font-weight: bold;
          }
        }
        margin-bottom: 15px;
      }
      .span-status{
        border: 1px solid #616266;
        color: #616266;
      }
      .card {
        margin-bottom: 15px;
      }

      .border-b {
        //margin: 10px -15px 0 -15px;
        padding: 0 15px 10px;
        border-bottom: 1px solid #dddfe7;

        .title {
          margin-bottom: 5px;
        }
      }

      .action-box {
        margin: 10px -15px 0 -15px;
        padding: 10px 15px;
        border-top: 1px solid #dddfe7;
        border-bottom: 1px solid #dddfe7;
      }

      .title {
        display: inline-block;
        margin-bottom: 10px;
        padding-top: 5px;
        font-size: 14px;
        font-weight: bold;
      }

      .el-input, .el-select {
        margin-bottom: 10px;

        & + .el-button {
          margin-bottom: 10px;
        }
      }
      .button-width{
        .el-button{
          width: 100%;
          font-size: 14px;
        }
      }
      .flex-align-center{
        align-items: center;
      }
      .customer-ava{
        height: 28px;
        width: 28px;
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
        background: #DBEDFF;
        margin-right: 10px;
        img{
          width: 100%;
          display: block;
          border-radius: 50%;
        }
      }
      .amount-payable {
        border: 1px solid rgba(4,66,137,0.2);
        border-radius: 10px;
        background-color: #DBEDFF;
        //margin-bottom: 30px;
        &.border-b{
          margin-top: 0;
        }
        .title {
          margin-bottom: 0;
          padding-top: 15px;
          padding-bottom: 5px;
        }

        .amount {
          display: block;
          padding-bottom: 20px;
          font-size: 28px!important;
          color: #586069;
        }
        .payment-disblock{
          display: block!important;
          .size-blue{
            color: #0366D6;
            font-family: Inter;
            font-size: 12px;
            cursor: pointer;
          }
        }
        .payment-status{
          display:flex ;
          justify-content: space-between;
          margin-bottom: 10px;
          .flex{
            align-items: center;
          }
          .dot{
            margin-right: 8px;
            display: block;
            border-radius: 50%;
            height: 16px;
            width: 16px;
            border: 1px solid rgba(0,0,0,0.2);
            background-color: #D73A49;
          }
          .green{
            background: #28A745!important;
          }
          .icon{
            margin-right: 5px;
          }
          .text-color{
            color: #0366D6;
            font-size: 12px;
          }
          .size-italic{
            font-style:italic;
            font-size: 12px;
            color: #6A737D;
          }
        }
        .send-color{
          color: #0366D6;
          font-size: 14px;
          font-weight: 500;
        }
        .button-list{
          margin: 20px 0;
          .el-button{
            margin-right: 8px;
            width: 50%;
            font-size: 14px;
          }
        }

      }

      .btn-list {
        .el-button {
          display: block;
          margin: 0 0 5px 0;
        }
      }

      .remark-add {
        z-index: 2;
        margin: 0 -15px;
        padding: 15px 15px 0 15px;
        //border-top: 1px solid #dddfe7;
      }

      .remarks-container {
        z-index: 1;
        max-height: 300px;
        overflow-y: auto;

        .remark-box {
          margin-bottom: 10px;
          font-size: 12px;
          color: #91939a;

          .remark-header {
            display: flex;
            justify-content: space-between;

            span:first-child {
              font-weight: bold;
            }
          }

          p {
            padding-bottom: 10px;
            color: #616266;
          }
        }
      }
    }
  }

  .dialog-container {
    padding-left: 15px;
    color: #616266;

    h1 {
      font-size: 24px;
    }

    .dialog-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin: 0 -15px;
      padding: 0 15px 15px 15px;
      border-bottom: 1px solid #dddfe7;

      h1 {
        font-size: 24px;
      }
    }

    .dialog-content {
      padding-top: 15px;

      & > div {
        flex: 1;
      }

      .left {
        margin-top: -15px;
        padding-right: 15px;
        padding-top: 15px;
        border-right: 1px solid #dddfe7;
      }

      .right {
        padding-left: 15px;
      }

      .form-box {
        margin-bottom: 10px;

        .label {
          display: block;
          padding-bottom: 5px;
          font-size: 14px;
          font-weight: bold;
        }
      }
    }
  }
  .void-status{
    background-color: #FFE3E6!important;
  }
  .paid-status{
    background-color: #DCFFE4!important;
  }
  .unbuyable-status{
    background-color: #FFFBDD!important;
  }
  .void-color{
    color: #CB2431;
  }
  .incomplete-status{
    background: #FFFBDD;
  }
  .main-header{
    padding: 20px 70px 0px 70px;
    border-bottom: 1px solid #D1D5DA;
    background-color: #FFF!important;
    ::v-deep .el-tabs__header{
      margin-bottom: 0;
    }
    .margin-bottom{
      padding-bottom: 20px;
    }
  }
}

.bg-yellow {
  margin: 0px -15px 0 -15px;
  padding: 20px 15px 15px 15px;
  background: #FFFBDD;
  display: flex;
  flex-direction: column;
  border-radius: 15px;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
    display: block;
  }
}
.bg-gray {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  background: #91939a;
  color: white;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-small-blue {
  background: #B3D9FF;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-block {
  margin: -15px -15px 0 -15px;
  padding: 20px 15px 20px 15px;
  p {
    padding-bottom: 10px;
    font-size: 14px;
    font-weight: 500;
  }
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-green {
  background: #28a745;
  color: white;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-red {
  background: #D73A49;
  color: white;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
.bg-danger {
  background: #f56c6d;
  color: white;
  .el-button{
    margin-left: 0;
    margin-bottom: 10px;
  }
}
::v-deep .edit-container{
  padding: 0px!important;
}
.tr-margin{
  margin-bottom: 10px;
}
.setting-menu{
  list-style: none;
  background: #FFFFFF;
  //border: 1px solid #E1E4E8;
  border-radius: 6px;
  z-index: 100;
  margin-top: 0!important;
  position: absolute;
  margin-left: 22px;
  box-shadow: 0 1px 8px 0 rgba(27, 31, 35, 0.4);
  //box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);

  li{
    width: 256px;
    height: 33px;
    background: #FFFFFF;
    font-family: Inter;
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    color: #24292E!important;
    box-shadow: inset 0px -1px 0px #E1E4E8;
    cursor: pointer;
    .with-icon{
      width: 11px!important;
    }
    i{
      width: 11px;
    }
    span{
      margin-left: 10px;
    }
    &:last-child{
      box-shadow: none!important;
    }
  }


}
.button-group{
  background: #FAFBFC;
  display: flex;
  border: 1px solid rgba(27, 31, 35, 0.15);
  box-sizing: border-box;
  box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04), inset 0px 2px 0px rgba(255, 255, 255, 0.25);
  border-radius: 6px 6px 6px 6px;
  height: 32px;
  align-items: center;
  width: 100%;
  margin-bottom: 10px;

  .span-one{
    .icon{
      font-family: Font Awesome 5 Free;
      font-style: normal;
      font-weight: 900;
      font-size: 14px;
      line-height: 16px;
      /* identical to box height, or 114% */

      display: flex;
      align-items: center;
      text-align: center;

      /* btn/outline/text */

      color: #0366D6;
    }
    span{
      margin-left: 10px;
    }
    color: #0366D6;
    border-right: 1px solid #E1E4E8;
    width: 60%;
    align-items: center;
    text-align: center;
    display: flex;
    cursor: pointer;
    height: 100%;
    justify-content: center;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
  }
  .span-two{
    color: #24292E;
    width: 100%;
    align-items: center;
    text-align: center;
    display: flex;
    cursor: pointer;
    height: 100%;
    justify-content: center;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    span{
      margin-right: 10px;
    }
  }
}
.border-left-blue {
  border-left: 5px solid #409EFF;
}
.border-left-warning {
  border-left: 5px solid #E6A23D;
}
.border-left-success {
  border-left: 5px solid #68C23A;
}
.box {
  //margin-top: 15px;
  .title{
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
  }
  .box-show{
    background: #F6F8FA;
    border-radius: 6px;
    padding: 10px;
    margin-bottom: 10px;
    margin-top: 10px;
    .title{
      font-style: normal;
      font-weight: 600;
      font-size: 12px;
      line-height: 18px;
      color: #24292E;
    }
    .email{
      word-break: break-all;
      position: relative;
      .tips{
        position: absolute;
      }
    }
  }
}
.span-status{
  padding: 2px 10px;
  color: #fff;
  border-radius: 50px;
  font-size: 14px;
  margin-right: 10px;
}
.yellow{
  background-color: #DBAB09;
}
.purple{
  background-color: #6F42C1;
}
.green{
  background: #28A745;
  color: #28A745!important;
}
.status-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 15px;
  //height: 50px;
  color: white;
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 30px;
  border: 1px solid rgba(23, 111, 44, 0.2);
  border-radius: 6px;
  &.snoozed {
    background: #E6A23D;
  }
  &.resolved {
    background: #DCFFE4;
    color: #24292E;
  }
  .check{
    color: #28A745!important;
  }
  .status-title {
    padding: 22px 0;
    span {
      display: flex;
      align-items: center;
    }
  }
  .svg-inline--fa {
    padding-right: 10px;
    color: white;
    font-size: 22px;
  }

}
.margin-top-none{
  margin-top: 0!important;
}
.main-header{
  background-color: #FFF!important;
  .button-radius{
    height: 18px;
    font-style: normal;
    font-weight: 600;
    font-size: 12px;
    line-height: 18px;
    display: flex;
    align-items: center;
    text-align: center;
    color: #24292E;
    padding: 1px 8px;
    background: #FFFFFF;
    border: 1px solid #6A737D;
    border-radius: 100px;
  }
  .ticket-number{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
    height: 20px;
  }
  .header-title{
    h3{
      font-style: normal;
      font-weight: normal;
      font-size: 24px;
      line-height: 36px;
      letter-spacing: 0.3px;
      color: #24292E;
    }
  }
  .flex-inline{
    align-items: flex-end;
  }
  .header-date{
    //height: 20px;
    font-style: normal;
    font-weight: 600;
    font-size: 14px;
    //line-height: 20px;
    color: #586069;
    margin-right: 0;
  }
  .number-fontsize{
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    //line-height: 20px;
    display: flex;
    align-items: center;
    color: #24292E;
    margin-left: 8px;
    margin-right: 15px;
  }
}
.add-policy-list {
  margin-top: 15px;
  .add-policy-item {
    margin-bottom: 15px;
    font-size: 12px;
    color: white;
    .add-policy-label {
      display: block;
      padding-bottom: 5px;
      cursor: pointer;
      .ic-right {
        margin-left: 5px;
        font-size: 12px;
        font-weight: 400;
      }
    }
    .bold {
      font-weight: bold;
    }
  }
}
.button-margin{
  margin-right: 8px!important;
}
.icon-backgroud-none{
  background: none!important;
  img{
    height: auto!important;
  }
}
.policy-span-status {
  background: none;
  border: 0px!important;
  &.green {
    color: #28a745!important;
  }
  &.orange {
    color: #E36209!important;
  }
  &.yellow-dark {
    color: #DBAB09!important;
  }
  &.blue {
    color: #0366D6!important;
  }
  &.red {
    color: #d73a49!important;
  }
  &.min-green {
    color: #dcffe4;
  }
  &.purple {
    color: #6F42C1;
  }
}
.plan-name{
  text-decoration: none!important;
}
.flex-icon{
  width: 70px;
  margin-right: 5px;
  display: flex;
  .icon{
    margin-right: 10px!important;
  }
  .icon-margin-top{
    margin-top: -1px;
  }
  //con-width{
  //  width: 22px;
  //  margin-right: 10px;
  //}
}

.status-box{
  padding: 15px;
  width: 280px;
  border-radius: 15px;
  &.yellow-bg{
    background: #FFFBDD;
    border: 1px solid rgba(176, 136, 0, 0.2);
  }
  &.blue-bg{
    background: #DBEDFF;
    border: 1px solid rgba(4, 66, 137, 0.2);
  }
  &.green-bg{
    background: #DCFFE4;
    border: 1px solid rgba(23, 111, 44, 0.2);
  }
  &.red-bg{
    background: #FFE3E6;
    border: 1px solid rgba(158, 28, 35, 0.2);
  }
  .box-title{
    font-weight: 600;
    font-size: 14px;
    line-height: 20px;
    color: #24292E;
    height: 20px;
  }
  .tips{
    font-weight: 400;
    font-size: 14px;
    margin-top: 10px;
  }
  .btn{
    margin-top: 10px;
    .el-button{
      height: 32px;
      border-radius: 6px;
      font-weight: 600;
      font-family: 'inter';
    }
    .green-btn{
      background: #2EA44F;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.1);
      color: #FFFFFF;
      /deep/.icon{
        color: rgba(255, 255, 255, 0.8);
      }
    }
    .gray-red-btn{
      color: #D73A49;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
    }
    .gray-black-btn{
      color: #24292E;
      background: #FAFBFC;
      border: 1px solid rgba(27, 31, 35, 0.15);
      box-shadow: 0px 1px 0px rgba(27, 31, 35, 0.04);
      /deep/.icon{
        color: #586069;
      }
    }
    .el-button+.el-button{
      margin: 0;
      margin-top: 10px;
    }
  }
}
span.edit{
  color: #0366D6;
  font-weight: 400;
  font-size: 14px;
  cursor: pointer;
}
.description-content{
  font-weight: 400;
  font-size: 14px;
  color: #24292E;
  margin-bottom: 15px;
}
.aside-dot{
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left:8px;
  ::v-deep .el-badge__content{
    color: #24292E;
    border:1px solid #E1E4E8;
    background: #FFFFFF;
  }
  &.is-info{
    ::v-deep .el-badge__content{
      color: #24292E;
      border:0;
      background: rgba(209, 213, 218, 0.5);
    }
  }
}
.circle{
  display: flex;
  align-items: center;
  justify-content: center; color: #24292E;
  margin-left:8px;
  border: 1px solid #24292E;
  border-radius: 25px;
  cursor: pointer;
  &:hover{
    //background: #0366D6;
    //opacity: 0.1;
    border-color: #0366D6;
    color: #0366D6;
    font-weight: 600;
  }
}
.red-color{
  color: $red;
}
</style>

